import { useRouteError } from 'react-router'

/** A page's own file that the server no longer has. Each deploy names its files
 *  afresh, so a tab left open across one asks for a file that has gone, and each
 *  browser words the failure its own way. */
export function isPageFileFailure(error: unknown): boolean {
  if (!(error instanceof Error)) return false
  return /dynamically imported module|importing a module script failed|unable to preload css/i.test(error.message)
}

/** What a reader sees when a page cannot be drawn, in place of the router's
 *  developer screen: what happened in a sentence and the way back. The error
 *  itself goes to the browser's console, where React has already put it. It needs
 *  nothing from the app, since the app is what failed. */
export function RouteError() {
  const updated = isPageFileFailure(useRouteError())
  return (
    <main className="pad route-error" role="alert">
      <h1>{updated ? 'The platform was updated' : 'This page could not be shown'}</h1>
      <p>{updated
        ? 'This tab still has the previous version open. Reload to get the new one.'
        : 'Something went wrong while drawing it. Your data is not affected. Reload to try again, and tell your administrator if it keeps happening.'}</p>
      <button type="button" className="button primary" onClick={() => window.location.reload()}>Reload</button>
    </main>
  )
}
